import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { FormattedMessage } from "react-intl";
import { Helmet } from "react-helmet";
import { useLinks, useList, useNetworkControls } from "hooks";
import Card from "components/Card";
import { Grid, PageWrapper } from "components/Containers";
import NoResults from "components/Messages/NoResults";
import { NetworkList, NetworkListControls } from "components/Network";
import PageTitle from "components/PageTitle";
import { PrimaryLink } from "components/Links";
import { ListNetworkSearchAdvancedOptions, ListShareButton } from "components/Lists";
import { SORT, NETWORK_LIST_SORTING_VALUES } from "constants/index";

/**
 * List
 */
const List = () => {
  const { slug } = useParams();
  const links = useLinks();
  const [profiles, setProfiles] = useState([]);
  const [list, setList] = useState({});
  const [profileIds, setProfileIds] = useState([]);
  const resultsPerPage = 18;
  const { data, loading } = useList({
    variables: {
      filters: {
        slug: slug,
      },
      includeProfileIds: true,
      includeBadgesFields: false,
      includeProfileBasicFields: false,
      includeProfileAvailabilityFields: false,
      includeDisciplineFields: false,
      includeSkillsFields: false,
      includeLocationFields: false,
      includeRateFields: false,
      includeWorkExperiencesFields: false,
      includeUser: true,
    },
  });
  const {
    filterMetadata,
    data: profilesData,
    ...rest
  } = useNetworkControls({
    resultsPerPage,
    variables: {
      includeProfileList: true,
      listId: list?.id,
    },
    initialValues: {
      sortKey: NETWORK_LIST_SORTING_VALUES.member_at,
      sortDirection: SORT.desc,
      filters: {
        profileIds,
      },
    },
    handleSkip: !profileIds.length,
  });

  useEffect(() => {
    if (data && data[0]) {
      const list = data[0];
      setList(list);
      setProfiles(list?.profiles);
    }
  }, [data]);

  useEffect(() => {
    if (profiles.length > 0) {
      setProfileIds(profiles.map((profile) => `${profile.id}`));
    }
  }, [profiles]);

  return (
    <PageWrapper>
      <Helmet>
        <title>{list?.title}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle
            title={list?.title}
            backLink={
              <PrimaryLink to={links.lists} routerEnabled>
                <FormattedMessage id="Lists.H1" />
              </PrimaryLink>
            }
            actionBar={<ListShareButton data={list} />}
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          {profileIds.length > 0 && (
            <NetworkListControls formValues={filterMetadata} hideKeywordSearch hideSorts {...rest} />
          )}
        </Grid.col>
        <Grid.col start={1} end={13}>
          {!loading && profiles.length === 0 && (
            <Card>
              <NoResults />
            </Card>
          )}
          {profileIds.length > 0 && (
            <NetworkList
              data={profilesData}
              rowOptions={{ component: ListNetworkSearchAdvancedOptions, defaultArgs: { list } }}
              {...rest}
            />
          )}
        </Grid.col>
      </Grid>
    </PageWrapper>
  );
};

export default List;
